import React from 'react';
import { Bookmark } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface BookmarkButtonProps {
  isBookmarked: boolean;
  onClick: (e: React.MouseEvent) => void;
  size?: 'small' | 'medium' | 'large';
}

const BookmarkButton: React.FC<BookmarkButtonProps> = ({
  isBookmarked,
  onClick,
  size = 'medium'
}) => {
  const sizeClasses = {
    small: 'h-6 w-6',
    medium: 'h-8 w-8',
    large: 'h-10 w-10'
  };

  const iconSizeClasses = {
    small: 'h-4 w-4',
    medium: 'h-5 w-5',
    large: 'h-6 w-6'
  };

  return (
    <Button
      variant={isBookmarked ? 'secondary' : 'outline'}
      size="icon"
      className={cn(sizeClasses[size])}
      onClick={onClick}
      aria-label={isBookmarked ? 'Remove bookmark' : 'Add bookmark'}
    >
      <Bookmark
        className={cn(iconSizeClasses[size])}
        fill={isBookmarked ? 'currentColor' : 'none'}
      />
    </Button>
  );
};

export default BookmarkButton;
